import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { WarningBody } from '../../model/warning_body';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.css']
})
export class WarningComponent implements OnInit {

  body : WarningBody = new WarningBody;

  closeIconSelected = false; 

  constructor(private element : ElementRef, private modalService : ModalService) {
    this.body.list_content = [];
   }

  ngOnInit() {
    console.log(this.body);
    // this.body.title=  "Código Vencido";
    // this.body.current_icon = "./assets/img/iconos_v2/e-peligro.svg";
    // this.body.main_button = "Continuar";
    // this.body.error_message = "Mensaje de Error";

  }

  show(body : WarningBody = new WarningBody){
    this.body = {
      current_icon : "./assets/img/modal_v2/e-peligro.png",
      text_align: "text-center", 
      list_content: [], ...body
    }
    this.element.nativeElement.style.visibility = "visible";
  }

  hide(){
    this.element.nativeElement.style.visibility = "hidden";
  }

  accept(){
    if (this.body.onMainAction) this.body.onMainAction();
    this.element.nativeElement.style.visibility = "hidden";
  }

  link(){
    this.element.nativeElement.style.visibility = "hidden";
    if(this.body.onLinkAction) this.body.onLinkAction();
  }

  closeDown(){
    this.closeIconSelected = true;
  }

  closeUp(){
    this.closeIconSelected = false;
  }

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/modals/warning/warning.component.ts